import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { removeCustomFilter, applyCustomFilter, setSaveEnabled } from 'store/Filters/actions';
import get from 'lodash/get';
import { shouldRedirect } from 'Common/Components/SearchBar/components/BasicFilter/functions';
import { ACTIONS, CATEGORIES } from 'tracking/GA/constants';
import { trackEvent } from 'tracking/GA';
import { CFLabel, CFContainer, RemoveIcon } from './styled';
import { getSelectedEntity } from 'store/Filters/selectors';
import { SEARCH_BY_ENTITIES } from 'store/Filters/entitiesConstants';
import { generalView, insideAsset } from 'store/Tabs/selectors';

const CustomFilterButton = ({ filter, entity }) => {
  const dispatch = useDispatch();
  const entityName = get(entity, 'name.value', 'vulns');
  const entityPathname = get(entity, 'pathname', '');
  const selectedEntity = useSelector(getSelectedEntity);
  const isOutsideWorkspace = useSelector(generalView);
  const isInsideAsset = useSelector(insideAsset);

  const trackSearch = () => {
    const trackAction = get(ACTIONS, `search.${entityName}.custom`, '');
    if (trackAction) dispatch(trackEvent(CATEGORIES.search, trackAction.name, trackAction.label));
  };

  const deleteCustomFilter = () => dispatch(removeCustomFilter(entityName, filter.id));

  const setCustomFilter = () => {
    dispatch(shouldRedirect(entityPathname, entityName, selectedEntity));
    if (selectedEntity.includes(entityName) && (entityName === 'vulns' || entityName === 'assets')) {
      dispatch(applyCustomFilter(entityName, filter.id, selectedEntity));
    } else if (!selectedEntity.includes(entityName) && isOutsideWorkspace) {
      const newEntity = SEARCH_BY_ENTITIES.find((e) => e.name.value.includes(entityName) && !e.wsDependant)?.name?.value;
      dispatch(applyCustomFilter(entityName, filter.id, newEntity));
    } else if (!selectedEntity.includes(entityName) && !isOutsideWorkspace && !isInsideAsset) {
      const newEntity = SEARCH_BY_ENTITIES.find((e) => e.name.value.includes(entityName) && e.wsDependant && !e.assetDependant)?.name?.value;
      dispatch(applyCustomFilter(entityName, filter.id, newEntity));
    }
    const selectedEntityObj = SEARCH_BY_ENTITIES.find((e) => selectedEntity === e.name.value);
    dispatch(selectedEntityObj.searchFunction());
    trackSearch();
    dispatch(setSaveEnabled(true));
  };

  return (
    <CFContainer>
      <CFLabel title={ filter.name } onClick={ setCustomFilter }>{filter.name}</CFLabel>
      <RemoveIcon onClick={ deleteCustomFilter } />
    </CFContainer>
  );
};

CustomFilterButton.propTypes = {
  filter: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired
};

export default CustomFilterButton;
